import { render, staticRenderFns } from "./LandingProductCard.vue?vue&type=template&id=62f0d7cc&scoped=true"
import script from "./LandingProductCard.vue?vue&type=script&lang=ts"
export * from "./LandingProductCard.vue?vue&type=script&lang=ts"
import style0 from "./LandingProductCard.vue?vue&type=style&index=0&id=62f0d7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f0d7cc",
  null
  
)

export default component.exports